"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deepEqual = void 0;
const deepEqual = (a, b) => {
    if (a === b)
        return true;
    if (a === null || b === null)
        return a === b;
    if (typeof a !== "object" || typeof b !== "object")
        return false;
    const aKeys = Object.keys(a);
    const bKeys = Object.keys(b);
    if (aKeys.length !== bKeys.length)
        return false;
    return [...new Set([...aKeys, ...bKeys])].every((key) => key in a &&
        key in b &&
        (0, exports.deepEqual)(a[key], b[key]));
};
exports.deepEqual = deepEqual;
//# sourceMappingURL=equal.js.map